import { Impose } from "@pdfking/imposition"
import { ImpositionSchemaForm } from "@pdfking/imposition-form"
import type { Hook, ImpositionSchema } from "@pdfking/imposition/internal"
import { HooksMarkingList } from "@pdfking/imposition/internal"

import type { Preset } from "./Preset"

export type ImpositionPresetOptions = Pick<Preset, "id" | "name" | "emoji" | "data"> &
  Partial<Pick<Preset, "size" | "hidden_fields" | "hooks_list" | "material_list">> & {
    // What the preset does to every job it imposes, after the job's markings.
    hook?: Hook
  }

/** A packing preset: the imposition form over `data`, its markings offered
 * from `hooks_list`. */
export const ImpositionPreset = ({
  hook = {},
  hidden_fields = [],
  hooks_list = HooksMarkingList,
  material_list = [],
  ...preset
}: ImpositionPresetOptions): Preset => ({
  ...hook,
  ...preset,
  hidden_fields,
  hooks_list,
  material_list,
  build_form: ImpositionSchemaForm,
  impose: value => Impose(value as ImpositionSchema, { hooks: [hook] }),
})
